module.exports = __webpack_public_path__ + "static/media/sm.1896d72b.png";